import comSwipe from './picSwipe.vue'

export default comSwipe
